// OWNER: workspace module. Route objects relative to /w/:wsId, spread into the router by src/app/router.tsx.
// Pages are lazy-loaded so each feature is its own chunk. Add routes here; don't edit the router.
import type { RouteObject } from 'react-router';

const pages = () => import('./pages');

export const routes: RouteObject[] = [
  { path: 'more/family', lazy: async () => ({ Component: (await pages()).FamilyPage }) },
  { path: 'more/principal', lazy: async () => ({ Component: (await pages()).PrincipalPage }) },
  { path: 'more/activity', lazy: async () => ({ Component: (await pages()).ActivityPage }) },
];

/** Public routes (absolute paths, outside the workspace shell): accepting an invite works signed in or out (FR-1.3). */
export const publicRoutes: RouteObject[] = [
  { path: '/invite/:wsId/:token', lazy: async () => ({ Component: (await pages()).InvitePage }) },
];
